import React, { type ComponentProps } from 'react';
import { StyleSheet, Text } from 'react-native';

import { type TextLink, theme, webOnlyProps } from '@sg/garnish';

/**
 * Link component for the bag header, to be used inside of the header display text.
 */
export const BagHeaderLink = (
  props: ComponentProps<typeof TextLink> & { isDisabled?: boolean; nonFocusable?: boolean },
) => {
  const {
    children,
    isDisabled = false,
    nonFocusable,
    accessibilityRole = 'button',
    accessibilityLabel,
    onPress,
  } = props;

  if (isDisabled) {
    return <Text>{children}</Text>;
  }

  return (
    <Text
      style={styles.linkingStyle}
      accessibilityRole={accessibilityRole}
      accessibilityLabel={accessibilityLabel}
      {...webOnlyProps({ tabIndex: nonFocusable ? -1 : undefined })}
      onPress={onPress}
    >
      {children}
    </Text>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  linkingStyle: {
    color: theme.colors.SPINACH,
    textDecorationLine: 'underline',
  },
});
